export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const BACKEND_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

Date.prototype.format = function (type = 'all', opt = { token: { date: '-', time: ':', split: ' ' } }) {
  const td = opt.token.date;
  const tt = opt.token.time;
  const ts = opt.token.split;
  const DD = `00${this.getDate()}`.slice(-2);
  const MM = `00${this.getMonth() + 1}`.slice(-2);
  const HH = `00${this.getHours()}`.slice(-2);
  const II = `00${this.getMinutes()}`.slice(-2);
  const SS = `00${this.getSeconds()}`.slice(-2);
  const YYYY = this.getFullYear();
  const date = `${YYYY}${td}${MM}${td}${DD}`;
  const time = `${HH}${tt}${II}${tt}${SS}`;
  return type === 'date'
    ? date
    : type === 'time'
      ? time
      : `${date}${ts}${time}`;
};

Date.prototype.isInvalid = function () {
  return isNaN(this.getTime());
};

export default Date;
